//Universal code that applies to all of the FAQs

$(document).ready(function() {
    //get the current url.
    var url = window.location.href;
    //split the array on the #. this is where the anchor link starts.
    url = url.split("#");
    if (url.length == 2 && url[1].length > 0) {
        //when a customer goes directly to an anchor link.

        //close all divs.
        $(".panel-collapse").removeClass("in");
        //all the first divs have the open-panel class. 
        //add collapsed class to this div.
        $(".open-panel").addClass('collapsed');
        //remove open-panel from the div.
        $(".open-panel").removeClass('open-panel');

        //set the id for the anchor link href.
        var link = url[1].replace("heading", "link");
        //remove collapsed class to open the div.
        $('#' + link).removeClass("collapsed");
        //add open-panel class.
        $('#' + link).addClass("open-panel");

        //set collapse id for the collapse anchor link div.
        var collapse = url[1].replace("heading", "collapse");
        $('#' + collapse).addClass("in");

        $('html,body').animate({
            scrollTop: $("#" + url[1]).offset().top
        });
    }
});


function AnchorLink(id) {
    //processes href anchor links.
    //close all divs.
    $(".panel-collapse").removeClass("in");
    //close all other the divs.
    $(".panel-collapse").addClass("collapse");
    //all the first divs have the open-panel class. 
    //add collapsed class to this div.
    $(".open-panel").addClass('collapsed');
    //remove open-panel from the div.
    $(".open-panel").removeClass('open-panel');
    $('[data-toggle]').addClass('collapsed');

    //get the value of the data-anchor attribue.
    var anchor = $('#' + id).attr("data-anchor");
    //set the id for the anchor link href.
    var link = anchor.replace("heading", "link");
    //remove collapsed class to open the div.
    $('#' + link).removeClass("collapsed");
    //add open-panel class.
    $('#' + link).addClass("open-panel");

    //set collapse id for the collapse anchor link div.
    var collapse = anchor.replace("heading", "collapse");
    $('#' + collapse).addClass("in");
    $('#' + collapse).removeClass("collapse");

    //set the height to auto. 
    $('#' + collapse).css("height", "auto");

    $('html,body').animate({
        scrollTop: $("#" + anchor).offset().top
    });
}